export const PATHS = {
  UPDATE: 'update',
  REQUIRED: 'required',
};
